import React from "react";
import {
  Filter,
  Create,
  TextInput,
  NumberInput,
  LongTextInput,
  SaveButton,
  NumberField,
  List,
  Datagrid,
  TextField,
  Pagination,
  ReferenceField,
  DateField,
  Button,
  Link,
  Toolbar,
  Edit,
  SimpleForm,
  EditButton,
  ReferenceInput,
  SelectInput,
  DateInput
} from "react-admin";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import moment from "moment";

const ListPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const vehicleTypes = [
  { _id: "1", description: "Van" },
  { _id: "2", description: "Bike" }
];

const MaintenanceItemTitle = object => (
  <span>
    {" Edit Maintenance Item entry "} {object.record.description}
  </span>
);

const MaintenanceItemCreateTitle = record => (
  <span>Create Maintenance Item Type entry</span>
);

const MaintenanceItemsListFilter = props => (
  <Filter {...props}>
    <TextInput label="Description" source="q" alwaysOn />
    <SelectInput
      source="vehicle_type"
      choices={vehicleTypes}
      optionText="description"
      optionValue="_id"
      alwaysOn
    />
  </Filter>
);

export const MaintenanceItemList = props => (
  <List
    {...props}
    title="Maintenance Items"
    resource="maintenance_items"
    pagination={<ListPagination />}
    bulkActionButtons={false}
    filters={<MaintenanceItemsListFilter />}
  >
    <Datagrid>
      <TextField label="Id" source="id" />
      <TextField label="Description" source="description" />
      <DateField label="Date" source="date" />
      <NumberField
        source="price"
        options={{ style: "currency", currency: "EUR" }}
      />
      <ReferenceField
        label="Vehicle Type"
        source="vehicle_type_id"
        reference="vehicle_types"
        linkType={false}
      >
        <TextField source="vehicle_type" />
      </ReferenceField>
      <ReferenceField
        label="Item Type"
        source="maintenance_item_type_id"
        reference="maintenance_item_types"
        linkType={false}
      >
        <TextField source="description" />
      </ReferenceField>
      <TextField label="Kms" source="rev_kms" />

      <EditButton />
      {/* <DeleteButton/> */}
    </Datagrid>
  </List>
);

const MaintenanceItemsToolbar = props => (
  <Toolbar {...props}>
    <SaveButton redirect={`/maintenance_items`} />
    {/* <DeleteButton record={props.record} resource={props.resource} redirect={`/maintenance_item_types`} />  */}
    <Button
      component={Link}
      to={{
        pathname: `/maintenance_items`
      }}
      label="Back to maintenance items"
    >
      <ArrowBackIcon />
    </Button>
  </Toolbar>
);

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

export const MaintenanceItemEdit = props => (
  <Edit title={<MaintenanceItemTitle />} {...props}>
    <SimpleForm toolbar={<MaintenanceItemsToolbar />}>
      <LongTextInput source="description" label="Description" />
      <DateInput label="Date" source="date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
      <NumberInput source="price" />
      <ReferenceInput
        label="Vehicle Type"
        source="vehicle_type_id"
        reference="vehicle_types"
      >
        <SelectInput source="id" optionText="vehicle_type" />
      </ReferenceInput>
      <ReferenceInput
        label="Item Type"
        source="maintenance_item_type_id"
        reference="maintenance_item_types"
        linkType={false}
      >
        <SelectInput source="id" optionText="description" />
      </ReferenceInput>
      <TextInput source="rev_kms" label="Kms" />
    </SimpleForm>
  </Edit>
);

export const MaintenanceItemCreate = props => (
  <Create title={<MaintenanceItemCreateTitle />} {...props}>
    <SimpleForm toolbar={<MaintenanceItemsToolbar />}>
      <LongTextInput source="description" label="Description" />
      <DateInput label="Date" source="date" locales="es-Es" options={{ timeZone: 'UTC' }} />
      <NumberInput source="price" />
      <ReferenceInput
        label="Vehicle Type"
        source="vehicle_type_id"
        reference="vehicle_types"
      >
        <SelectInput source="id" optionText="vehicle_type" />
      </ReferenceInput>
      <ReferenceInput
        label="Item Type"
        source="maintenance_item_type_id"
        reference="maintenance_item_types"
        linkType={false}
        perPage={1000}
      >
        <SelectInput source="id" optionText="description" />
      </ReferenceInput>
      <TextInput source="rev_kms" label="Kms" />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/maintenanceItems.js